import React from 'react';

function NotFoundPage() {
  return (
    <h1>Page Not found</h1>
  );
};

export default NotFoundPage;
